// ============================================
// DEMOGRAPHIC CONSTANTS
// ============================================

export const AGE_BUCKETS = [
  { key: '18-24', labelHe: '24-18' },
  { key: '25-34', labelHe: '34-25' },
  { key: '35-44', labelHe: '44-35' },
  { key: '45-54', labelHe: '54-45' },
  { key: '55+', labelHe: '+55' },
] as const;

export type AgeBucketKey = typeof AGE_BUCKETS[number]['key'] | 'unknown';

export const GENDERS = {
  male: { key: 'male', labelHe: 'גברים' },
  female: { key: 'female', labelHe: 'נשים' },
  other: { key: 'other', labelHe: 'אחר' },
} as const;

export type GenderKey = keyof typeof GENDERS;
export type DemographicDimension = 'age' | 'gender';

export const MIN_SEGMENT_SIZE = 8;

// Individual View: demographic comparison series colors (muted, earthy, brand-aligned)
export const DEMOGRAPHIC_COLORS = {
  ageGroup: '#6d8a6e',     // Sage green - earthy, distinct
  genderGroup: '#9c7092',  // Dusty mauve - warm, distinct
} as const;

// Group View: segment colors for comparison charts (muted earthy palette, brand-aligned)
export const SEGMENT_COLORS: Record<string, string> = {
  '18-24': '#2c5d63', '25-34': '#6d8a6e', '35-44': '#c17d5f',
  '45-54': '#9c7092', '55+': '#5e7d94', 'unknown': '#b9b1a2',
  'male': '#2c5d63', 'female': '#c17d5f', 'other': '#b9b1a2',
};

export const DEMOGRAPHIC_LABELS = {
  age: 'קבוצת גיל',
  gender: 'מגדר',
  ageGroup: 'ממוצע קבוצת גיל',
  genderGroup: 'ממוצע מגדר',
  viewByAge: 'לפי גיל',
  viewByGender: 'לפי מגדר',
  breakdownToggle: 'פירוט משני',
  unknown: 'לא צוין',
  tooFewRespondents: 'מעט מדי משתתפים להצגה',
  all: 'הכל',
} as const;
